<template>
  <div
    class="market-switcher-trigger"
    :class="`market-switcher-trigger--${layout}`"
  >
    <div class="market-switcher-trigger__buttons">
      <button
        class="
          market-switcher-trigger__country
          market-switcher-trigger__button
        "
        type="button"
        @click="handleDrawerOpen('countries')"
      >
        <img
          class="market-switcher-trigger__flag"
          alt=""
          :src="currentCountry.flagSrc"
        >

        <span
          :class="textClasses.link"
          v-text="countryString"
        />
      </button>

      <button
        class="
          market-switcher-trigger__language
          market-switcher-trigger__button
        "
        type="button"
        @click="handleDrawerOpen('languages')"
      >
        <span
          :class="[
            textClasses.label,
            { 'visually-hidden': layout === 'small' }
          ]"
          v-text="`${$string('market_switcher.language')}:`"
        />

        <span
          :class="textClasses.link"
          v-text="languageString"
        />
      </button>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Market switcher trigger (market-switcher-trigger)
 * -----------------------------------------------------------------------------
 * Button to trigger the market switcher overlay.
 *
 * @param {String} layout - Type of layout; `large` or `small`
 *
 */
import { mapActions, mapState } from 'vuex'

export default {
  name: 'MarketSwitcherTrigger',

  props: {
    layout: {
      type: String,
      default: 'large',
      required: true,
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      currentCountry: (state) => state['market-switcher'].currentCountry,
    }),

    /**
     * Compute country string.
     * @returns {String}
     */
    countryString() {
      return this.layout === 'small'
        ? this.currentCountry.name
        : this.currentCountry.label
    },

    /**
     * Compute language string.
     * @returns {String}
     */
    languageString() {
      return this.$variable('store.language')?.toUpperCase()
    },

    /**
     * Compute text classes.
     * @returns {Object}
     */
    textClasses() {
      return {
        label: this.layout === 'small'
          ? 'text-body-2xs'
          : 'text-body-xs',
        link: this.layout === 'small'
          ? 'text-body-2xs-link'
          : 'text-body-xs-link',
      }
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
      setDisplay: 'market-switcher/setDisplay',
    }),

    /**
     * Handle drawer open.
     * @param {String} [display] - What to display in drawer.
     */
    handleDrawerOpen(display = 'countries') {
      this.setDisplay(display)

      this.openOverlay({
        component: 'market-switcher-drawer',
        ignoreDismissed: true,
        namespace: 'marketSwitcherDrawer',
      })
    },
  },
}
</script>

<style lang="scss">
@import './market-switcher-trigger';
</style>
